module.exports = __webpack_public_path__ + "static/media/icon_5.a260aa67.svg";